import Icon from '@ant-design/icons';
import { GetProps } from 'antd';
import { ReactComponent as IconComponent } from './Icon.svg';

const LogoIcon = (props: GetProps<typeof Icon>) => <Icon {...props} component={IconComponent}  />;

export { LogoIcon };
